import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'

export default function ScrollToTop (props) {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return props.children || null
}

ScrollToTop.propTypes = {
  children: PropTypes.element.isRequired
}
